import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from './ForgotCredentials.ducks';
import { OPTION_FORGOT_USERNAME, OPTION_FORGOT_PASSWORD } from './ForgotCredentials.ducks';
import Button from 'zignal-landscape/lib/Button';
import ButtonGroup from 'zignal-landscape/lib/ButtonGroup';
import Input from 'zignal-landscape/lib/Input';
import Label from 'zignal-landscape/lib/Label';
import Link from 'zignal-landscape/lib/Link';
import Modal from 'zignal-landscape/lib/Modal';
import ModalHeader from 'zignal-landscape/lib/ModalHeader';
import ModalBody from 'zignal-landscape/lib/ModalBody';
import ModalFooter from 'zignal-landscape/lib/ModalFooter';
import Radio from 'zignal-landscape/lib/Radio';
import { isValidEmailAddress } from 'helpers/email';

export const mapStateToProps = (
  (state) => {
    return {
      selectedOption: state.ForgotCredentialsModal.selectedOption,
      activeWizardStepIndex: state.ForgotCredentialsModal.activeWizardStepIndex,
      isMobileSize: state.ForgotCredentialsModal.isMobileSize,
      emailAddress: state.ForgotCredentialsModal.emailAddress
    };
  }
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

const modalBodyStyle = (isMobileSize) => {
  return { height: isMobileSize ? '105px' : '80px' };
};

const forgotSectionStyle = {
  display: 'flex',
  alignItems: 'baseline'
};

const ForgotCredentialsModal = ({
  isOpen,
  onClose,
  selectedOption,
  emailAddress,
  isMobileSize,
  activeWizardStepIndex,
  handleEmailInputChange,
  handleModalClose,
  handleRadioChange,
  handleNextButtonClick,
  handleBackButtonClick,
  handleScreenResize,
  requestForgottenCredentials
}) => {

  // Cleanup state and trigger onClose prop
  const handleClose = () => {
    handleModalClose();
    onClose();
  };

  const chooseCredentialType = (
    <div>
      <ModalHeader onClose={handleClose}>
        Login Help
      </ModalHeader>
      <ModalBody>
        <div style={modalBodyStyle(isMobileSize)}>
          <p>What did you forget?</p>
          <div>
            <Radio
              id="forgotUsername"
              name={OPTION_FORGOT_USERNAME}
              onChange={handleRadioChange}
              checked={selectedOption === OPTION_FORGOT_USERNAME}
            />
            <Label htmlFor="forgotUsername" inline>I forgot my username</Label>
          </div>
          <div style={forgotSectionStyle}>
            <Radio
              id="forgotPassword"
              name={OPTION_FORGOT_PASSWORD}
              onChange={handleRadioChange}
              checked={selectedOption === OPTION_FORGOT_PASSWORD}
            />
            <Label htmlFor="forgotPassword" inline>I forgot my password and need to reset it</Label>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonGroup align="right">
          <Link linkType="cancel" onClick={handleClose}>Cancel</Link>
          <Button buttonStyle="positive" onClick={handleNextButtonClick}>Next</Button>
        </ButtonGroup>
      </ModalFooter>
    </div>
  );

  const emailPrompt = selectedOption === OPTION_FORGOT_PASSWORD ?
    "Enter the email address you used with your account and we'll send you instructions to reset your password." :
    "Enter the email address you used with your account and we'll send you information about your username.";

  const emailForm = (
    <div>
      <ModalHeader onClose={handleClose}>
        Login Help
      </ModalHeader>
      <ModalBody>
        <div style={modalBodyStyle(isMobileSize)}>
          <p>{emailPrompt}</p>
          <Input placeholder="Enter email address" onChange={handleEmailInputChange} />
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonGroup align="right">
          <Link linkType="cancel" onClick={handleClose}>Cancel</Link>
          <Button onClick={handleBackButtonClick}>Go Back</Button>
          <Button
            buttonStyle="positive"
            disabled={!isValidEmailAddress(emailAddress)}
            onClick={() => {
              requestForgottenCredentials({credentialType: selectedOption, email: emailAddress});
            }}
          >
            Send
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </div>
  );

  const sentPrompt = selectedOption === OPTION_FORGOT_PASSWORD ?
    'Please check your email for further instructions to reset your password.' :
    'Please check your email for your username information.';

  const emailSent = (
    <div>
      <ModalHeader onClose={handleClose} headerStyle="positive" hideCloseButton>
        Request Sent
      </ModalHeader>
      <ModalBody>
        <div style={modalBodyStyle(isMobileSize)}>
          {sentPrompt} The instructions will be sent if your email address is associated with an account.
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonGroup align="right">
          <Button buttonStyle="positive" onClick={handleClose}>Ok</Button>
        </ButtonGroup>
      </ModalFooter>
    </div>
  );

  const wizardSteps = [
    chooseCredentialType,
    emailForm,
    emailSent
  ];

  const modalSize = isMobileSize ? 'large' : 'medium';

  if (!window.onresize) {
    window.onresize = handleScreenResize;
  }

  return (
    <Modal isOpen={isOpen} onBackdropClick={handleClose} size={modalSize}>
      {wizardSteps[activeWizardStepIndex]}
    </Modal>
  );
};

ForgotCredentialsModal.propTypes = {
  isOpen: PropTypes.bool,
  isMobileSize: PropTypes.bool,
  onClose: PropTypes.func,
  selectedOption: PropTypes.string,
  emailAddress: PropTypes.string,
  activeWizardStepIndex: PropTypes.number,
  handleEmailInputChange: PropTypes.func,
  handleModalClose: PropTypes.func,
  handleRadioChange: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  handleBackButtonClick: PropTypes.func,
  handleScreenResize: PropTypes.func,
  requestForgottenCredentials: PropTypes.func
};

export default connect(mapStateToProps, actions, mergeProps)(ForgotCredentialsModal);
